import { IEffortDto, IOrchestrationDto, IOrchestrationTargetingRuleDto, ITargetingRuleDto } from './../../models/orchestrations';
import { Injectable, TemplateRef } from '@angular/core';
import { OrchestrationEndpointService } from './orchestration-endpoint.service';

@Injectable({
  providedIn: 'root'
})
export class OrchestrationService {

    public currentFormTemplate: TemplateRef<any>;
    public deleteChecked: boolean;

    constructor(private endpointService: OrchestrationEndpointService) { }

    public getEfforts(): Promise<IEffortDto[]> {
        return this.endpointService.getEfforts();
    }

    public getOrchestrations(): Promise<IOrchestrationDto[]> {
        return this.endpointService.getOrchestrations();
    }

    public getOrchestrationTargetingRules(): Promise<IOrchestrationTargetingRuleDto[]> {
        return this.endpointService.getOrchestrationTargetingRules();
    }

    public getTargetingRules(): Promise<ITargetingRuleDto[]> {
        return this.endpointService.getTargetingRules();
    }

    public saveEffortChanges(request: IEffortDto): Promise<IEffortDto> {
        return this.endpointService.saveEffortChanges(request);
    }

    public saveOrchestrationChange(request: IOrchestrationDto): Promise<IOrchestrationDto> {
        return this.endpointService.saveOrchestrationChanges(request);
    }

    public saveOrchestrationTargetingRuleChange(request: IOrchestrationTargetingRuleDto): Promise<IOrchestrationTargetingRuleDto> {
        return this.endpointService.saveOrchestrationTargetingRuleChange(request);
    }

    public saveTargetingRuleChange(request: ITargetingRuleDto): Promise<ITargetingRuleDto> {
        return this.endpointService.saveTargetingRuleChange(request);
    }

    public saveCreateEffortChanges(request: IEffortDto): Promise<IEffortDto> {
        return this.endpointService.saveCreateEffortChanges(request);
    }

    public saveCreateOrchestrationChange(request: IOrchestrationDto): Promise<IOrchestrationDto> {
        return this.endpointService.saveCreateOrchestrationChanges(request);
    }

    public saveCreateOrchestrationTargetingRuleChange(request: IOrchestrationTargetingRuleDto): Promise<IOrchestrationTargetingRuleDto> {
        return this.endpointService.saveCreateOrchestrationTargetingRuleChange(request);
    }

    public saveCreateTargetingRuleChange(request: ITargetingRuleDto): Promise<ITargetingRuleDto> {
        return this.endpointService.saveCreateTargetingRuleChange(request);
    }

    public saveDeleteEffortChanges(request: IEffortDto): Promise<IEffortDto> {
        return this.endpointService.saveDeleteEffortChanges(request);
    }

    public saveDeleteOrchestrationChange(request: IOrchestrationDto): Promise<IOrchestrationDto> {
        return this.endpointService.saveDeleteOrchestrationChanges(request);
    }

    public saveDeleteOrchestrationTargetingRuleChange(request: IOrchestrationTargetingRuleDto): Promise<IOrchestrationTargetingRuleDto> {
        return this.endpointService.saveDeleteOrchestrationTargetingRuleChange(request);
    }

    public saveDeleteTargetingRuleChange(request: ITargetingRuleDto): Promise<ITargetingRuleDto> {
        return this.endpointService.saveDeleteTargetingRuleChange(request);
    }
}
